import { render, staticRenderFns } from "./bibAssignment.vue?vue&type=template&id=1eff49d3&scoped=true"
import script from "./bibAssignment.vue?vue&type=script&lang=js"
export * from "./bibAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff49d3",
  null
  
)

export default component.exports